import {RestService} from "@/services/rest/RestService";
import {CustomerProductsAPIApi} from "@/api/pharma-cpc-product-mgmt";
import {
    CustomerProductOverviewRestDto, CustomerProductRestDto, IdResponseRestDto,
    PagedCustomerProductOverviewRestDto
} from "@/api/pharma-cpc-product-mgmt/models";
import {PhotoRestService} from "@/services/rest/photo/PhotoRestService";
import {AxiosResponse} from "axios";
import {
    CustomerProductWithImageOverviewRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CustomerProductWithImageOverviewRestDtoModel";
import {
    PagedCustomerProductWithImageOverviewRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/PagedCustomerProductWithImageOverviewRestDtoModel";
import {
    CustomerProductWithImageDetailRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CustomerProductWithImageDetailRestDtoModel";
import {validateCustomerProduct} from "@/store/pharma-cpc-product-mgmt/middleware";

export class CustomerProductsRestService extends RestService {

    private apiService: CustomerProductsAPIApi;

    protected constructor() {
        super();

        this.apiService = new CustomerProductsAPIApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().cpcUrl);
    }

    public async findCustomerProducts(languageCode: string): Promise<PagedCustomerProductWithImageOverviewRestDtoModel> {
        const response: AxiosResponse<PagedCustomerProductOverviewRestDto> = await this.apiService.findCustomerProducts();

        const result: PagedCustomerProductWithImageOverviewRestDtoModel = new PagedCustomerProductWithImageOverviewRestDtoModel(
            response.data.paging_metadata ?? null,
            response.data.results.map((product: CustomerProductOverviewRestDto) => new CustomerProductWithImageOverviewRestDtoModel(product))
        )

        await PhotoRestService.getInstance().fillCustomerProductImageUrls(result.results, languageCode);

        return result;
    }

    public async getCustomerProduct(productCode: string, languageCode: string): Promise<CustomerProductWithImageDetailRestDtoModel> {
        const response: AxiosResponse<CustomerProductRestDto> = await this.apiService.getCustomerProduct(productCode);
        const product: CustomerProductRestDto = response.data;
        const imageUrl: string = await PhotoRestService.getInstance().getProductImageUrl(product.cnk_code, null, languageCode);

        return new CustomerProductWithImageDetailRestDtoModel(product, imageUrl);
    }

    public async createCustomerProduct(body: CustomerProductRestDto): Promise<string> {
        validateCustomerProduct(body);
        const response: AxiosResponse<IdResponseRestDto> = await this.apiService.createCustomerProduct(body);

        return response.data.id;
    }

    public async updateCustomerProduct(productCode: string, body: CustomerProductRestDto): Promise<void> {
        validateCustomerProduct(body);
        await this.apiService.updateCustomerProduct(body, productCode);
    }

    public async deleteCustomerProduct(productCode: string): Promise<void> {
        await this.apiService.deleteCustomerProduct(productCode);
    }
}
